module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNOC43MjA1OCA4LjI1MTE1QzguMzI3MTggOC42NTk5OSA3LjY3MjgyIDguNjU5OTkgNy4yNzk0MiA4LjI1MTE1TDAuOTY5MTk3IDEuNjkzMzhDMC4zNTc4NzcgMS4wNTgwNyAwLjgwODExNCA0LjA0Mzg2ZS0wNyAxLjY4OTc3IDQuODE0NjNlLTA3TDE0LjMxMDIgMS41ODQ3OGUtMDZDMTUuMTkxOSAxLjY2MTg2ZS0wNiAxNS42NDIxIDEuMDU4MDcgMTUuMDMwOCAxLjY5MzM4TDguNzIwNTggOC4yNTExNVoiIGZpbGw9IiM1NjM0MEMiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/triangle.svg
// module id = SnNW
// module chunks = 0